import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    LoggedTopbar: {
      position: 'fixed',
      width: '100%',
      top: 0,
      left: 0,
      right: 'auto'
    },
    LoggedTopbarShift: {
      marginLeft: '271px',
      width: 'calc(-271px + 100vw)'
    },
    LoggedDrawerPaper: {
      zIndex: 1200,
      width: '271px',
      background: 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      '@media (max-width: 768px)': {
        display: 'none'
      }
    },
    LoggedDrawerCookies: {
      zIndex: 1500,
      position: 'fixed',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    LoggedSidebar: {
      width: '270px'
    },
    LoggedContent: {
      marginTop: '64px'
    },
    LoggedContentShift: {
      marginLeft: '270px',
      '@media (max-width: 768px)': {
        marginLeft: '0px'
      }
    },
    LoggedMainContainer: {
      padding: '25px',
      maxWidth: '1320px',
      margin: 'auto',
      '@media (min-width: 768px)': {
        marginBottom: '127px',
        marginTop: '10px'
      }
    },
    bottomMenuContainer: {
      display: 'none',
      '@media (max-width: 768px)': {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        position: 'fixed',
        bottom: '0em',
        height: '64px',
        marginLeft: '-25px',
        zIndex: 10
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
